export const CATEGORIES = [
  "Office Supplies",
  "Travel",
  "Meals & Entertainment",
  "Transportation",
  "Postage & Shipping",
  "Printing",
  "Maintenance",
  "Miscellaneous",
];

export const CURRENCIES = [
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "\u20ac", name: "Euro" },
  { code: "GBP", symbol: "\u00a3", name: "British Pound" },
  { code: "JPY", symbol: "\u00a5", name: "Japanese Yen", decimals: 0 },
  { code: "CNY", symbol: "\u00a5", name: "Chinese Yuan" },
  { code: "KRW", symbol: "\u20a9", name: "South Korean Won", decimals: 0 },
  { code: "CAD", symbol: "CA$", name: "Canadian Dollar" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "TWD", symbol: "NT$", name: "New Taiwan Dollar", decimals: 0 },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "THB", symbol: "\u0e3f", name: "Thai Baht" },
  { code: "PHP", symbol: "\u20b1", name: "Philippine Peso" },
  { code: "INR", symbol: "\u20b9", name: "Indian Rupee" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "MXN", symbol: "MX$", name: "Mexican Peso" },
];

export const DEFAULT_CURRENCY = "USD";

export const CURRENCY_MAP = Object.fromEntries(
  CURRENCIES.map((c) => [c.code, c]),
);

export const STORAGE_KEYS = {
  TRANSACTIONS: "pct_transactions",
  FUND_BALANCE: "pct_fund_balance",
};

export const COLORS = {
  primary: "#2563eb",
  primaryDark: "#1d4ed8",
  primaryLight: "#dbeafe",
  success: "#16a34a",
  successLight: "#dcfce7",
  danger: "#dc2626",
  dangerLight: "#fee2e2",
  warning: "#d97706",
  warningLight: "#fef3c7",
  gray50: "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#9ca3af",
  gray500: "#6b7280",
  gray600: "#4b5563",
  gray700: "#374151",
  gray800: "#1f2937",
  gray900: "#111827",
  white: "#ffffff",
};
